import type { ApiReturnCampaign } from '@highimpact-frontend/api-types';
import { useQuery } from '@tanstack/react-query';

import { useDashboardHost } from '../context/DashboardHostContext';
import { dashboardQueryKeys } from './queryKeys';

export interface UseCampaignsQueryResult {
  readonly campaigns: readonly ApiReturnCampaign[];
  readonly loading: boolean;
  readonly error: boolean;
}

/**
 * Loads site-scoped campaigns via {@link DashboardHostApi.campaign}.
 */
export function useCampaignsQuery(
  siteId: number | null | undefined
): UseCampaignsQueryResult {
  const host = useDashboardHost();

  const query = useQuery({
    queryKey: dashboardQueryKeys.campaigns(siteId),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => host.api.campaign.getBySite(siteId!),
    enabled: siteId != null,
    staleTime: 60_000,
  });

  return {
    campaigns: query.data ?? [],
    loading: siteId != null && query.isPending,
    error: query.isError,
  };
}
